import React, { useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { inp } from "./e360Primitives";

export default function CoBrandingEditor({ clientId, logoUrl, roster, onSaved }) {
  const [logo, setLogo] = useState(logoUrl || "");
  const [rows, setRows] = useState(
    (roster && roster.length ? roster : [{ role: "", name: "" }]).map((r) => ({ role: r.role || "", name: r.name || "" }))
  );
  const [busy, setBusy] = useState(false);

  const setRow = (i, k, v) => setRows(rows.map((r, idx) => (idx === i ? { ...r, [k]: v } : r)));
  const addRow = () => setRows([...rows, { role: "", name: "" }]);
  const delRow = (i) => setRows(rows.filter((_, idx) => idx !== i));

  const save = async () => {
    setBusy(true);
    try {
      const exec_roster = {};
      rows.forEach((r) => { if (r.role.trim() && r.name.trim()) exec_roster[r.role.trim()] = r.name.trim(); });
      await api.put(`/admin/enterprise360/clients/${clientId}`, { client_logo_url: logo.trim() || null, exec_roster });
      toast.success("Co-branding & roster saved");
      onSaved && onSaved();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); }
    finally { setBusy(false); }
  };

  return (
    <details data-testid="e360-cobranding" className="border border-zinc-200 rounded-lg p-4 mb-5">
      <summary className="cursor-pointer text-[12px] tracking-[0.14em] uppercase text-[var(--e360-primary)] font-semibold">
        Co-branding &amp; engagement roster
      </summary>
      <div className="mt-4 space-y-4">
        <div>
          <label className="text-xs text-zinc-500">Client logo URL (appears on every Kit PDF)</label>
          <div className="flex items-center gap-3 mt-1">
            <input data-testid="e360-client-logo-url" className={inp} value={logo}
              onChange={(e) => setLogo(e.target.value)} placeholder="https://cdn.client.com/logo.png" />
            {logo ? <img src={logo} alt="logo" style={{ height: 32, width: "auto" }} className="ek-logo-on-dark border border-zinc-200 rounded" /> : null}
          </div>
        </div>
        <div>
          <label className="text-xs text-zinc-500">Engagement roster — map roles to real executives (shown across all exports)</label>
          <div className="space-y-2 mt-1">
            {rows.map((r, i) => (
              <div key={i} className="flex items-center gap-2">
                <input data-testid={`e360-roster-role-${i}`} className={inp} value={r.role}
                  onChange={(e) => setRow(i, "role", e.target.value)} placeholder="Role (e.g. Process Owner)" />
                <input data-testid={`e360-roster-name-${i}`} className={inp} value={r.name}
                  onChange={(e) => setRow(i, "name", e.target.value)} placeholder="Executive name" />
                <button onClick={() => delRow(i)} className="text-zinc-400 hover:text-rose-600 shrink-0"><Trash2 size={15} /></button>
              </div>
            ))}
          </div>
          <button onClick={addRow} className="mt-2 text-[12px] tracking-[0.14em] uppercase text-[var(--e360-primary)] flex items-center gap-1">
            <Plus size={13} /> Add role
          </button>
        </div>
        <button data-testid="e360-cobranding-save" onClick={save} disabled={busy}
          className="bg-[var(--e360-primary)] text-white px-5 py-2.5 text-[12px] tracking-[0.16em] uppercase disabled:opacity-50">
          {busy ? "Saving…" : "Save co-branding & roster"}
        </button>
      </div>
    </details>
  );
}
